var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{ref:"dataTree",attrs:{"check-strictly":true,"node-key":"id","props":_vm.props,"load":_vm.loadNode,"lazy":"","show-checkbox":""},on:{"check-change":_vm.handleCheckChange}})}
var staticRenderFns = []

export { render, staticRenderFns }